import { Icon } from '@acpaas-ui/react-components';

const ModalTitle = ({ title = '', subtitle = '', hasError }) => {
  return (
    <>
      <h6 className={`spo-m-modal__title ${hasError ? 'u-text-danger' : ''}`}>
        {hasError && <Icon name="ai-alert-triangle" />}
        {title}
      </h6>
      {subtitle && <p className="u-margin-top-xs">{subtitle}</p>}
    </>
  );
};

export default ModalTitle;
